
define('text!v3/Pages/WayOfWork/Components/WowDropdown/WowDropdown.Component.html',[],function () { return '<dropdown params="options: availableSubjectCategories, value: subjectCategory, optionsText: subjectCategoryLocalizedName" data-bind="visible:availableSubjectCategories().length"></dropdown>';});

